import React from "react";
import { cn } from "../../../utils/cn";

const steps = ["Account", "Property", "Review"];

export const WizardStepsDemo: React.FC = () => {
  const activeIndex = 1;
  return (
    <ol className="flex flex-wrap items-center gap-3" aria-label="Registration steps">
      {steps.map((label, index) => {
        const state = index < activeIndex ? "done" : index === activeIndex ? "current" : "upcoming";
        return (
          <li key={label} className="flex items-center gap-2">
            <span
              className={cn(
                "flex h-9 w-9 items-center justify-center rounded-full border-2 text-xs font-semibold",
                state === "done" && "border-[#38A169] bg-[#38A169] text-white",
                state === "current" && "border-[#3182CE] bg-white text-[#3182CE]",
                state === "upcoming" && "border-[#E2E8F0] bg-white text-[#A0AEC0]"
              )}
              aria-current={state === "current" ? "step" : undefined}
            >
              {index + 1}
            </span>
            <span
              className={cn(
                "text-sm font-medium",
                state === "current" && "text-[#2D3748]",
                state !== "current" && "text-[#718096]"
              )}
            >
              {label}
            </span>
            {index < steps.length - 1 ? (
              <span className="mx-1 hidden text-[#CBD5E0] sm:inline" aria-hidden>
                →
              </span>
            ) : null}
          </li>
        );
      })}
    </ol>
  );
};
